<template>
  <div class="price-chart-stats">
    <h3 class="price-chart-stats__title">
      {{ $t('kano.price-chart.stats.title', {
        cryptoCode: props.cryptoCurrency.code,
        cryptoName: props.cryptoCurrency.name,
      }) }}
    </h3>
    <div class="price-chart-stats__items">
      <div class="price-chart-stats-item">
        <div class="price-chart-stats-item__wrapper">
          <h5 class="price-chart-stats-item__label">
            {{ $t('kano.price-chart.stats.mktcap') }}
          </h5>
          <BaseTooltip>
            {{ $t('kano.price-chart.stats.mktcap.tooltip') }}
          </BaseTooltip>
        </div>
        <div class="price-chart-stats-item__value">
          {{ formatCompactAmount(props.marketInformation.mktcap, props.fiatCurrency.code) }}
        </div>
      </div>
      <div class="price-chart-stats-item">
        <div class="price-chart-stats-item__wrapper">
          <h5 class="price-chart-stats-item__label">
            {{ $t('kano.price-chart.stats.volume24h') }}
          </h5>
          <BaseTooltip>
            {{ $t('kano.price-chart.stats.volume24h.tooltip') }}
          </BaseTooltip>
        </div>
        <div class="price-chart-stats-item__value">
          {{ formatCompactAmount(props.marketInformation.volume24h, props.fiatCurrency.code) }}
        </div>
      </div>
      <div class="price-chart-stats-item">
        <div class="price-chart-stats-item__wrapper">
          <h5 class="price-chart-stats-item__label">
            {{ $t('kano.price-chart.stats.high24h') }}
          </h5>
          <BaseTooltip>
            {{ $t('kano.price-chart.stats.high24h.tooltip') }}
          </BaseTooltip>
        </div>
        <div class="price-chart-stats-item__value">
          {{ formatCompactAmount(props.marketInformation.high24h, props.fiatCurrency.code) }}
        </div>
      </div>
      <div class="price-chart-stats-item">
        <div class="price-chart-stats-item__wrapper">
          <h5 class="price-chart-stats-item__label">
            {{ $t('kano.price-chart.stats.supply') }}
          </h5>
          <BaseTooltip>
            {{ $t('kano.price-chart.stats.supply.tooltip') }}
          </BaseTooltip>
        </div>
        <div class="price-chart-stats-item__value">
          {{ formatAmount(props.marketInformation.supply) }}
          {{ props.cryptoCurrency.code }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { CryptoMarketInformation, PriceChartCryptoCurrency, PriceChartCurrency } from "@kano/types/crypto-price-chart";
import { i18n } from "@kano/i18n";
import { formatNumberCompact, formatNumberStandard, CurrencyFormat } from "@kano/helpers/numberFormatter";
import { Currency } from "@kano/types";
import { BaseTooltip } from '@kano/components/ui/tooltip';

const props = defineProps<{
  cryptoCurrency: PriceChartCryptoCurrency,
  fiatCurrency: PriceChartCurrency,
  marketInformation: CryptoMarketInformation,
}>();

const formatAmount = (amount: number) => {
  return formatNumberStandard(amount, i18n.locale);
}
const formatCompactAmount = (amount: number, currency: Currency|null) => {
  return formatNumberCompact(amount, i18n.locale, currency, CurrencyFormat.symbol);
}
</script>